import {DetailedProps, join} from '@esgi/ui-kit/utils';
import {forwardRef} from 'react';
import styles from './styles.module.less';

export const TableColumn = forwardRef<HTMLDivElement, DetailedProps<HTMLDivElement>>(
	({className, ...props}, ref) => (
		<div className={join(styles.tableColumn, className)} ref={ref} {...props}/>
	)
);
